import React from 'react'
import { Typography, Box } from 'transfix-ui/core'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { dataUnavailableForOlderRateMessage } from 'apps/marketplace/pages/spot-quote-tool/constants'
import { Card, CardHeader } from 'transfix-ui'

const useStyles = makeStyles(theme => ({
  singleCard: {
    marginTop: theme.spacing(2),
  },
}))

export const SpotRulesSection = () => {
  const classes = useStyles()
  return (
    <Box mt={4}>
      <Typography variant='subtitle1'>Spot Rules</Typography>
      <Card className={classes.singleCard}>
        <CardHeader>
          <Typography variant='h4'>Spot Quote Rules</Typography>
        </CardHeader>
        <Typography variant='h3' color='textSecondary'>
          {dataUnavailableForOlderRateMessage}
        </Typography>
      </Card>
    </Box>
  )
}
